<template>
    <div class="userCenter">
        <header>
            <nav class="site-navbar" :class="'site-navbar--' + navbarLayoutType">
                <div class="site-navbar__header">
                    <h1 class="site-navbar__brand" @click="$router.push({ name: 'home' })">
                        <a class="site-navbar__brand-lg" href="javascript:;">
                            <span style="padding-left: 5px">{{systemName}}</span>
                        </a>
                        <a class="site-navbar__brand-mini" href="javascript:;">
                        </a>
                    </h1>
                </div>
                <div class="site-navbar__body">
                    <el-menu
                        class="site-navbar__menu"
                        mode="horizontal">
                        <el-menu-item v-if="hasLogin" class="site-navbar__switch" index="10">
                            <icon-svg name="zhedie"></icon-svg>
                        </el-menu-item>
                        <el-menu-item index="11">
                            用户中心
                        </el-menu-item>
                    </el-menu>
                    <el-menu
                        class="site-navbar__menu site-navbar__menu--right"
                        mode="horizontal">
                        <el-submenu index="3" v-if="hasLogin">
                            <template slot="title"> {{ user.displayName || '游客' }}</template>
                            <el-menu-item index="1-1" @click.native="logoutHandle()">退出登录</el-menu-item>
                        </el-submenu>
                        <el-menu-item class="site-navbar__avatar" index="3" @click.native="$router.push({ name: 'login' })"
                                      v-if="!hasLogin">
                            登录
                        </el-menu-item>
                    </el-menu>
                </div>
            </nav>
        </header>
        <div class="useCenterMain">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="cardTitle">基本信息</span>
                </div>
                <template>
                    <el-form class="form viewFormWrapper demo-form-inline " label-width="175px" style="margin-bottom: 10px">
                        <div class="securityInfo" style="margin-bottom: 10px">
                            <el-row :span="20">
                                <el-col :span="20">
                                    <el-form-item>
                                        <span slot="label" class="securityInfo_title">用户名：</span>
                                        <span>{{ user.userinfo.username || '-' }}</span>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <el-row :span="20">
                                <el-col :span="12">
                                    <el-form-item prop="tenderAgencyName">
                                        <span slot="label" class="securityInfo_title">姓名：</span>
                                        <template v-if="!editFlag">
                                            <span>{{ user.displayName || '-' }}</span>
                                            <span class="textBtn" style="margin-left: 20px" @click="editName()">修改</span>
                                        </template>
                                        <div v-else style="display: flex">
                                            <el-input v-model="editRealName" maxlength="50" placeholder="请输入内容"
                                                      show-word-limit
                                                      style="margin-right: 20px;width:400px"></el-input>
                                            <el-button type="primary" @click="saveName()">保存</el-button>
                                        </div>
                                    </el-form-item>

                                </el-col>
                            </el-row>
                            <el-row :span="20">
                                <el-col :span="12">
                                    <el-form-item prop="tenderAgencyPhone">
                                        <span slot="label" class="securityInfo_title">所属部门：</span>
                                        <span>{{ user.tenderAgencyName || '-' }}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </el-form>
                </template>

            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="cardTitle">安全信息</span>
                </div>
                <template>
                    <el-form class="form viewFormWrapper demo-form-inline " label-width="175px" style="margin-bottom: 10px">
                        <div class="securityInfo" style="margin-bottom: 10px">
                            <el-row :span="24">
                                <el-col :span="20">
                                    <el-form-item>
                                        <span slot="label" class="securityInfo_title">设置密码：</span>
                                        <span class="securityInfo_des">建议您定期更换密码</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <p class="btn" @click="changePassword">修改密码</p>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="securityInfo" style="margin-bottom: 10px">
                            <el-row :span="24">
                                <el-col :span="20">
                                    <el-form-item>
                                        <span slot="label" class="securityInfo_title">手机绑定：</span>
                                        <span v-if="user.userinfo.mobile" class="securityInfo_des">{{ safeMobile }}</span>
                                        <span v-else class="securityInfo_des">当前未绑定手机号码</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <p v-if="user.userinfo.mobile" class="btn" @click="onclickBindTelPhone()">更换手机号码</p>
                                    <p v-else class="btn" @click="onclickBindTelPhone()">立即绑定</p>
                                </el-col>
                            </el-row>
                        </div>
                    </el-form>
                </template>

            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="cardTitle">CA证书（锁）</span>
                </div>
                <el-button style="margin-bottom: 10px" type="primary" @click="onclickAddCA">添加CA锁</el-button>
                <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        header-align="center"
                        label="序号"
                        type="index"
                        width="80">
                    </el-table-column>
                    <el-table-column
                        label="证书名称"
                        prop="friendlyName"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        label="序列号"
                        prop="caCode"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        label="到期时间"
                        prop="expireDate"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="操作" prop="address" width="120">
                        <template slot-scope="scope">
                            <span class="textBtn" @click="onclickUnbindCA(scope.row.id)">解绑</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <el-dialog :visible.sync="dialogVisible"
                       width="600px"
                       @closed="dialogClose"
                       destroy-on-close
                       :show-close="false"
                       custom-class="customDialog"
                       :close-on-click-modal="false"
            >
                <div v-if="dialogShowType===0"> <!--身份验证-->
                    <div slot="title" class="customDialog__title">
                        <span>身份验证</span>
                        <i class="el-icon-close" @click="dialogVisible = false"></i>
                    </div>
                    <div class="customDialog__body">
                        <div class="userinfoVerfiy_content">
                            <p class="topTips">为了您的账号安全，请先进行身份验证</p>
                            <div class="btnList">
                                <div v-for="(item, index) in tabList"
                                     :key="index"
                                     :class="[currentTabName === item ?'buttonActive' :``,`item_btn${index}`]"
                                     class="item_btn"
                                     :style="{width: tabList.length==3 ? '200px' :  (tabList.length==2?'300px':'500px')}"
                                     type="text"
                                     @click="selectTab(item)"
                                >
                                    <span> {{ item }}</span>
                                </div>
                            </div>
                            <div>
                                <template v-if="currentTabName === '密码验证'">
                                    <el-form ref="verifyDataForm" :model="verifyDataForm" :rules="dataRule"
                                             style="width: 100%;" @keyup.enter.native="dataFormSubmit()">
                                        <el-form-item prop="orignPassword">
                                            <el-row :gutter="20">
                                                <el-col :span="24">
                                                    <el-input
                                                        v-model="verifyDataForm.orignPassword"
                                                        placeholder="请输入密码"
                                                        type="password"
                                                        show-password
                                                    ></el-input>
                                                </el-col>
                                            </el-row>
                                        </el-form-item>
                                        <el-form-item prop="captcha">
                                            <el-row :gutter="25">
                                                <el-col :span="15">
                                                    <el-input
                                                        v-model="verifyDataForm.captcha"
                                                        placeholder="请输入验证码"
                                                    >
                                                    </el-input>
                                                </el-col>
                                                <el-col :span="1" class="login-captcha">
                                                    <img :src="captchaPath" alt="" @click="getCaptcha()"/>
                                                </el-col>
                                            </el-row>
                                        </el-form-item>
                                    </el-form>
                                </template>
                                <template v-if="currentTabName === '短信验证'">
                                    <el-form ref="verifyDataForm" :model="verifyDataForm" :rules="dataRule">
                                        <p class="telPhone">您的手机号为：{{ safeMobile }}</p>
                                        <el-form-item class="code_box" prop="verificationCode">
                                            <el-input v-model.trim="verifyDataForm.verificationCode"
                                                      placeholder="请输入短信验证码"></el-input>
                                            <div class="line"></div>
                                            <span v-show="show" class="getCode send_btn"
                                                  @click="getSendphoneCode(user.userinfo.mobile)">获取验证码</span>
                                            <span v-show="!show" class="count send_btn">{{ count }}s</span>
                                        </el-form-item>
                                    </el-form>
                                </template>
                                <template v-if="currentTabName === 'CA验证'">
                                    <el-form>
                                        <div class="look">
                                            <img src="../../assets/img/lock.png" alt="">
                                        </div>
<!--                                        <el-form-item>-->
<!--                                            <el-button style="width: 100%;" type="primary" @click="requestVerfiyUseinfo">验证CA锁</el-button>-->
<!--                                        </el-form-item>-->
                                    </el-form>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="customDialog__footer">
                        <el-button  type="primary" @click="requestVerfiyUseinfo">下一步</el-button>
                        <el-button  @click="dialogVisible = false" style="margin-left: 16px">取消</el-button>
                        <p class="tips yz" @mouseenter="showCon=true" @mouseleave="showCon=false">以上验证方式都不可用？</p>
                        <div v-if="showCon" class="tips_con">
                            <p>可通过以下渠道联系客服人员</p>
                            <p class="contact">客服QQ群：465366072</p>
                            <p class="contact">客服电话：0395-2961908</p>
                        </div>
                    </div>
                </div>
                <div v-else-if="dialogShowType===2"> <!--修改密码-->
                    <div slot="title" class="customDialog__title">
                        <span>设置新密码</span>
                        <i class="el-icon-close" @click="dialogVisible = false"></i>
                    </div>
                    <div class="customDialog__body">
                        <div class="userinfoVerfiy_content">
                            <p class="topTips">为了您的账号安全，请在3分钟内完成密码变更！</p>
                            <el-form ref="dataForm" :model="dataForm" :rules="dataRule" @keyup.enter.native="dataFormSubmit()" label-position="left" :label-width="formLabelWidth">
                                <el-form-item label="新密码" prop="password">
                                    <el-input
                                        v-model.trim="dataForm.password"
                                        type="password"
                                        show-password
                                        clearable
                                        placeholder="请输入新密码"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="再次输入" prop="confirmPassword">
                                    <el-input
                                        v-model.trim="dataForm.confirmPassword"
                                        type="password"
                                        show-password
                                        clearable
                                        placeholder="请再次输入新密码"
                                    ></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div slot="footer" class="customDialog__footer">
                        <el-button type="primary" @click="dataFormSubmit">确 定</el-button>
                        <el-button @click="dialogVisible = false" style="margin-left: 16px">取 消</el-button>
                    </div>
                </div>
                <div v-else-if="dialogShowType===3"> <!--更换手机号码-->
                    <div slot="title" class="customDialog__title">
                        <span>设置新手机号</span>
                        <i class="el-icon-close" @click="dialogVisible = false"></i>
                    </div>
                    <div class="customDialog__body">
                        <div class="userinfoVerfiy_content">
                            <p class="topTips">为了您的账号安全，请在3分钟内完成手机号变更！</p>
                            <el-form ref="dataForm" :model="dataForm" :rules="dataRule" @keyup.enter.native="dataFormSubmit()">
                                <el-form-item class="code_box" prop="telPhone">
                                    <el-input v-model.trim="dataForm.telPhone" placeholder="请输入新手机号"></el-input>
                                </el-form-item>
                                <el-form-item class="code_box" prop="verificationCode">
                                    <el-input v-model.trim="dataForm.verificationCode" placeholder="请输入验证码"></el-input>
                                    <div class="line"></div>
                                    <span v-show="show" class="getCode send_btn"
                                          @click="validateCheckPhone">获取验证码</span>
                                    <span v-show="!show" class="count send_btn">{{ count }}s</span>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div slot="footer" class="customDialog__footer">
                        <el-button type="primary" @click="onlickChangeMobile">确 定</el-button>
                        <el-button @click="dialogVisible = false" style="margin-left: 16px">取 消</el-button>
                    </div>
                </div>
                <div v-else-if="dialogShowType===4"> <!--添加CA锁-->
                    <div slot="title" class="customDialog__title">
                        <span>添加 CA 锁</span>
                        <i class="el-icon-close" @click="dialogVisible = false"></i>
                    </div>
                    <div class="customDialog__body">
                        <div class="userinfoVerfiy_content">
                            <p class="topTips">为了您的账号安全，请在3分钟内完成CA绑定！</p>
                            <div class="caCell">
                                <span class="caCell_title">证书名称</span>
                                <el-input v-model.trim="CAInfo.friendlyName" disabled placeholder="证书名称"></el-input>
                                <el-button plain type="primary" style="margin-left: 12px" @click="onclickGetCAInfo">获取</el-button>
                            </div>
                            <div class="caCell">
                                <span class="caCell_getTip">请插入CA锁后点击获取按钮</span>
                            </div>
                            <div class="caCell">
                                <span class="caCell_title">序列号</span>
                                <el-input v-model.trim="CAInfo.caCode" disabled placeholder="序列号"></el-input>
                            </div>
                            <div class="caCell" style="margin-top: 24px">
                                <span class="caCell_title">有效期</span>
                                <el-input v-model.trim="CAInfo.expireDate" disabled placeholder="有效期"></el-input>
                            </div>
                        </div>

                    </div>
                    <div slot="footer" class="customDialog__footer">
                        <el-button type="primary" @click="onclickConfirmAddCA">添 加</el-button>
                        <el-button @click="dialogVisible = false" style="margin-left: 16px">取 消</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="unbidDialogVisible" center title="解绑CA证书" width="30%" @closed="dialogClose" destroy-on-close>
                <p style="text-align: center">是否解绑该CA证书？</p>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="unbidDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleUnBind('activateFrom')">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {initCa, getCaInfo, SignData} from '../../plugins/pmca.js'
import {getUUID} from "../../utils";
import '@/assets/scss/useCenter.scss'
import {mapState} from "vuex";
import {logout} from '@/utils/login'
import debounce from "lodash/debounce";
import Crypto from '@/utils/crypto';

export default {
    props: ['mainContentViewHeight'],
    data() {
        var validateConfirmPassword = (rule, value, callback) => {
            if (this.dataForm.password !== value) {
                callback(new Error('确认密码与新密码不一致'))
            } else {
                callback()
            }
        }
        return {
            tabList: ["密码验证", "短信验证", "CA验证"],
            currentTabName: "密码验证",
            dataForm: {
                captcha: '',
                password: '',
                confirmPassword: '',
                verificationCode: '',
                telPhone: '',
                identityCode: '', //身份验证的code，/api/user/checkIdentity接口里返回的data
            },
            captchaPath: "",
            formLabelWidth: '100px',
            editFlag: false,
            showCon: false,
            tableData: [],
            bidDialogVisible: false,//添加CA锁
            unbidDialogVisible: false,  //解绑CA锁
            changePasswordVisible: false,// 修改密码弹窗.
            authenticationVisible: false,//  身份验证
            bindPhoneVisible: false,
            dataRule: {
                password: [
                    {required: true, message: '密码不能为空', trigger: 'blur'},
                    {min: 8, max: 32, message: '长度在 8 到 32 个字符', trigger: 'blur'},
                    {
                        pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}$/,
                        message: "必须同时包含大写字母、小写字母和数字",
                        trigger: "blur"
                    },
                ],
                confirmPassword: [
                    {required: true, message: '确认密码不能为空', trigger: 'blur'},
                    {validator: validateConfirmPassword, trigger: 'blur'}
                ],
                orignPassword: [{required: true, message: '原密码不能为空', trigger: 'blur'},],
                captcha: [{required: true, message: '验证码不能为空', trigger: 'blur'},],
                telPhone: [
                    {required: true, message: '手机号码不能为空', trigger: 'blur'},
                    {
                        pattern: /^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[35678]|9[1389])\d{1}))\d{7}$/,
                        message: "填写正确的手机号码",
                        trigger: "blur"
                    }
                ],
                verificationCode: [{required: true, message: '验证码不能为空', trigger: 'blur'},],
            },
            show: true,
            count: '',
            timer: null,
            editRealName: '', //编辑中的姓名
            employeeData: {}, //接口返回的原始数据
            verifyDataForm: {
                orignPassword: '', //原密码
                captcha: '', //验证码
                verificationCode: '', //手机短信验证码
            }, //身份验证的表单数据
            businessType: 2, //标记身份验证后的业务处理   2：修改密码  3：更换手机号码 4：添加CA锁
            dialogShowType: 0, //标记弹框的展示  0：身份验证 1：超时提示 2：修改密码  3：更换手机号码 4：添加CA锁
            CAInfo: {
                id: '',
                corpId: '',
                tradeOrgId: '',
                caCode: '',
                expireDate: '',
                friendlyName: '',
                fromDate: '',
                remark: '',
                userId: '-1',
                signData: ''
            },
            dialogVisible: false, //标记弹框是否展示
        }
    },
    computed: {
        ...mapState(["user"]),
        navbarLayoutType: {
            get() {
                return this.$store.state.common.navbarLayoutType
            }
        },
        hasLogin: {
            get() {
                return this.$store.state.user.id !== '' && this.$store.state.user.id !== undefined
            }
        },
        systemName: {
            get() {
                return window.SITE_CONFIG.siteName?window.SITE_CONFIG.siteName: '基础平台配置'
            }
        },
        isSupperAdmin: {
            get() {
                return this.user.supperAdmin === true || this.user.supperAdmin === 'true'
            }
        },
        safeMobile: {
            get() {
                const reg = /^(\d{3})\d{4}(\d{4})$/;
                return this.user.userinfo.mobile ? this.user.userinfo.mobile.replace(reg, "$1****$2") : '';
            }
        },
        hasBindMobile: {
            get() {
               return this.user.userinfo.mobile ? true : false
            }
        },
    },
    watch: {
        // currentTabName: {
        //     handler(val) {
        //         if (val === "CA验证") {
        //             this.onclickGetCAInfo()
        //         }
        //     },
        //     immediate: true
        // },
        dialogVisible: {
            handler(val) {
                if(val) {
                    this.getCaptcha()
                }
            },
            immediate: true
        }
    },
    mounted() {
        console.log(this.user.id)
        this.editRealName = this.user.displayName
        this.init(this.user.id)

        this.CAInfo.userId = this.user.id
        this.requestGetCAList() //获取锁列表数据
    },

    activated() {
    },
    methods: {
        //处理业务时请求返回身份验证无效的处理
        handleBusinessVerfiyError(){
            this.$confirm('身份验证已失效，请重新进行身份验证', '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
            }).then(() => {
                this.dialogShowType = 0
                this.dialogClose()
            })
        },
        //请求身份验证
        requestVerfiyUseinfo() {
            let verfiyData = {}
            if (this.currentTabName === "密码验证") {
                verfiyData = {
                    id: this.user.id,
                    type: 0,
                    oldPwd: Crypto.encrypt(this.verifyDataForm.orignPassword),
                    captcha: this.verifyDataForm.captcha
                }
            } else if (this.currentTabName === "短信验证") {
                verfiyData = {
                    id: this.user.id,
                    type: 1,
                    msgValid: this.verifyDataForm.verificationCode,
                }
            } else if (this.currentTabName === "CA验证") {
                verfiyData = {
                    id: this.user.id,
                    type: 2,
                    tradeOrgId: this.user.orgId,
                    caCode: this.CAInfo.caCode
                }
            }
            this.$http.post('/api/user/checkIdentity', verfiyData).then(({data}) => {
                if (data && data.code === '1') {
                    this.dataForm.identityCode = data.data
                    this.dialogShowType = this.businessType
                    this.initTimer()
                } else {
                    this.$message.error(data.msg)
                    this.getCaptcha() //刷新图片验证码
                }
            })
        },
        //身份验证切换tab
        selectTab(item) {
            this.currentTabName = item
            if(item === "CA验证") {
                this.onclickGetCAInfo()
            }
        },
        //请求解绑CA锁
        requestUnbindCA(id) {
            this.$http.delete('/sys/syscainfo/delete', {
                params: {
                    'ids': id
                }
            }).then(({data}) => {
                if (data && data.code === '1') {
                    this.requestGetCAList() //刷新锁列表数据
                    this.$message({
                        message: 'CA解绑成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        //点击解绑CA
        onclickUnbindCA(id) {
            this.$confirm('是否解绑该CA证书?', '解绑CA证书', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.requestUnbindCA(id)
            })
        },
        //获取CA锁列表
        requestGetCAList() {
            const data = {
                'filter': {
                    'orgId': this.CAInfo.corpId,
                    'userId': this.CAInfo.userId
                },
                'page': 1,
                'rows': 100,
            }
            console.log('获取锁列表参数：', data)
            this.$http.post('/sys/syscainfo/list', data).then(({data}) => {
                if (data) {
                    this.tableData = data.rows;
                } else {
                    this.tableData = [];
                }
            })
        },
        //请求添加CA锁
        requestAddCA() {
            const data = {
                ...this.CAInfo,
                'id': this.user.id,
                'identityCode': this.dataForm.identityCode
            }
            this.$http.post('/api/user/saveCa', data).then(({data}) => {
                if (data && data.code === '1') {
                    this.requestGetCAList() //刷新锁列表数据
                    this.$message({
                        message: 'CA绑定成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            this.dialogVisible = false
                        }
                    })
                } else {
                    if(data.code === '9002' || data.code === '9001') {
                        this.handleBusinessVerfiyError()
                    }else {
                        this.$message.error(data.msg)
                    }
                }
            })
        },
        //点击确定添加CA锁
        onclickConfirmAddCA() {
            this.requestAddCA()
        },
        //点击获取锁信息
        onclickGetCAInfo() {
            initCa((isIE) => {
                if (!isIE) {
                    this.$alert(
                        "请使用ie10及以上浏览器",
                        "提示",
                        {confirmButtonText: "确定"}
                    );
                }
            })

            try {
                let tempCertInfo = {}
                getCaInfo((certInfo) => {
                    tempCertInfo = certInfo
                })
                //要先获取caInfo，再SingData，因为SignData里需要用到CaInfo的random
                this.CAInfo.signData = SignData()

                console.log('signData:', this.CAInfo.signData)
                //通过是否有signData来判断是否正确输入过密码
                if (!this.CAInfo.signData) {
                    this.$alert('请确认CA是否正确插入', '提示', {
                        confirmButtonText: '确定',
                    })
                    return
                }else {
                    this.CAInfo.caCode = tempCertInfo.certserial
                    this.CAInfo.friendlyName = tempCertInfo.subject_cn
                    this.CAInfo.expireDate = tempCertInfo.validendtime
                    this.CAInfo.fromDate = tempCertInfo.validstarttime
                    this.CAInfo.remark = tempCertInfo.certName
                    this.$forceUpdate()
                }

            } catch (error) {
                this.$alert(
                    "请检查CA驱动是否安装成功！",
                    "提示",
                    {confirmButtonText: "确定"}
                );
            }
        },
        //点击添加CA锁
        onclickAddCA() {
            this.dialogVisible = true;
            this.dialogShowType = 0;
            this.businessType = 4;
            this.tabList = this.hasBindMobile ? ["密码验证", "短信验证"] :["密码验证"];
            this.currentTabName = "密码验证"
        },
        //请求修改手机号码
        requestChangePhone() {
            const data = {
                'id': this.user.id,
                'phone': this.dataForm.telPhone,
                'identityCode': this.dataForm.identityCode
            }
            this.$http({
                url: '/api/user/changePhone',
                method: 'post',
                data: data
            }).then(({data}) => {
                if (data && data.code === '1') {
                    const msg = this.user.userinfo.mobile ? "手机号修改成功" : "手机号绑定成功"
                    const userinfo = this.user.userinfo
                    userinfo.mobile = this.dataForm.telPhone
                    this.$store.commit('user/updateUser', userinfo)
                    this.$message({
                        message: msg,
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            this.dialogVisible = false
                        }
                    })
                } else {
                    if(data.code === '9002' || data.code === '9001') {
                        this.handleBusinessVerfiyError()
                    }else {
                        this.$message.error(data.msg)
                    }
                }
            })
        },
        //验证手机验证码
        validateCaptchaByPhone() {
            this.$http.post(`/sendphone/validateCaptchaByPhone?type=0&phone=${this.dataForm.telPhone}&captcha=${this.dataForm.verificationCode}`).then(res => {
                if (res.data.code == 1) {
                    this.requestChangePhone()
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        //验证用户手机号是否已被使用
        validateCheckPhone() {
            const data = {
                id: this.user.id,
                phone: this.dataForm.telPhone
            }
            this.$http.post(`/api/user/checkPhone`, data).then(res => {
                if (res.data.code == 1) {
                    this.getSendphoneCode(this.dataForm.telPhone)
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        //点击设置新手机号码
        onlickChangeMobile() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.validateCaptchaByPhone()
                }
            })
        },
        //获取手机短信验证码
        getSendphoneCode: debounce(
            function (phone) {
                this.$http.post(`/sendphone/sendcaptcha?type=0&phone=${phone}`).then(res => {
                    if (res.data.code !== '1') {
                        this.$alert(res.data.msg, '警告', {
                            confirmButtonText: '确定',
                        })
                        return;
                    }
                    this.$notify({
                        title: '发送验证码',
                        message: res.data.msg,
                        position: 'bottom-right'
                    })
                    const TIME_COUNT = 60;
                    if (!this.timer) {
                        this.count = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= TIME_COUNT) {
                                this.count--;
                            } else {
                                this.show = true;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                })
            },
            5000,
            {leading: true}
        ),
        //点击更新手机号码/绑定手机号码
        onclickBindTelPhone() {
            this.dialogVisible = true;
            this.dialogShowType = 0;
            this.businessType = 3;
            this.tabList = this.hasBindMobile ? ["密码验证", "短信验证", "CA验证"] :["密码验证", "CA验证"];
            this.currentTabName = this.hasBindMobile ? "短信验证" : "密码验证";
        },
        init(id) {
            this.$http({
                url: `/auth/employee/get?id=${id}`,
                method: 'post'
            }).then(({data}) => {
                if (data && data.code === '1') {
                    this.employeeData = data.data
                }
            })
        },
        //修改
        editName() {
            this.editFlag = true
        },
        //保存
        saveName() {
            //提交数据
            const dataForm = {
                ...this.employeeData,
                realName: this.editRealName
            }
            this.$http({
                url: '/auth/employee/saveorupdate',
                method: 'post',
                data: dataForm
            }).then(({data}) => {
                if (data && data.code === '1') {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                    })
                    this.editFlag = false
                    this.$store.commit('user/updateDisplayName', data.data.realName)
                } else {
                    this.$message.error(data.msg)
                    this.editRealName = this.user.displayName
                }
            })
        },
        dialogClose() {
            this.verifyDataForm = {}
            this.dataForm = {}
            this.CAInfo = {
                userId: this.user.id
            }
            this.initTimer()
        },
        //还原获取短信验证码定时
        initTimer() {
            this.show = true
            this.count = ''
            clearInterval(this.timer)
            this.timer = null
        },
        //解绑弹窗确定按钮
        handleUnBind() {
            this.unbidDialogVisible = false;
        },
        //请求修改密码
        requestChangePassword() {
            const data = {
                'id': this.user.id,
                'password': Crypto.encrypt(this.dataForm.password),
                'identityCode': this.dataForm.identityCode
            }
            this.$http({
                url: '/api/user/updateUserPwd',
                method: 'post',
                data: data
            }).then(({data}) => {
                if (data && data.code === '1') {
                    this.$message({
                        message: '密码修改成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            this.dialogVisible = false
                        }
                    })
                } else {
                    if(data.code === '9002' || data.code === '9001') {
                        this.handleBusinessVerfiyError()
                    }else {
                        this.$message.error(data.msg)
                    }
                }
            })
        },
        // 修改密码表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.requestChangePassword()
                }
            })
        },
        //修改密码
        changePassword() {
            this.dialogVisible = true;
            this.dialogShowType = 0;
            this.businessType = 2;
            this.tabList = this.hasBindMobile ? ["密码验证", "短信验证", "CA验证"] :["密码验证", "CA验证"];
            this.currentTabName = "密码验证"
        },
        //获取图片验证码
        getCaptcha() {
            const uuid = getUUID()
            this.captchaPath = this.$http.adornUrl(`/sso/captchaCode.png?uuid=${uuid}`)
        },
        // 退出
        logoutHandle() {
            this.$confirm(`确定进行[退出]操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                logout()
            })
        }
    },
    components: {},
}
</script>


